module.exports = {
      id: "comm-health-usage",
      viewBox: "0 0 321.539 50.773",
      url: "/" + "sprite-ab56b996b385d9abaaf31e01c38c81cd.svg#comm-health",
      toString: function () {
        return this.url;
      }
    }